/**
 * @generated SignedSource<<151bba9b6c36c70b4c2c9226483867ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditInstructorScreen_InstructorFragment$data = {
  readonly description: string | null | undefined;
  readonly id: string;
  readonly location: string | null | undefined;
  readonly name: string;
  readonly portraitFile: {
    readonly id: string;
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly signatureFile: {
    readonly id: string;
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly superId: string;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "EditInstructorScreen_InstructorFragment";
};
export type EditInstructorScreen_InstructorFragment$key = {
  readonly " $data"?: EditInstructorScreen_InstructorFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditInstructorScreen_InstructorFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditInstructorScreen_InstructorFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "superId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "portraitFile",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "signatureFile",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "InstructorImpl",
  "abstractKey": null
};
})();

(node as any).hash = "999b795a2437aaf9ea6484d935782837";

export default node;
